import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

const lightbox = new PhotoSwipeLightbox({
    gallery: '#foto-gallery',
    children: 'a',
    pswpModule: () => import('photoswipe')
    // pswpModule: PhotoSwipe
})

lightbox.init()